var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEndFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26.6666667px",
    height: "32.3804442px",
    viewBox: "0 0 26.6666667 32.3804442",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flag") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flag",
    transform: "translate(-6.6667, -4.2844)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 40 0 40 40 0 40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66666667,8.33333333 C6.66666667,7.88560979 6.8469281,7.45673981 7.16666667,7.14333333 C10.9366814,3.44762844 16.9301251,3.31919229 20.855,6.85 L21.44,7.39666667 C23.9545701,9.59984055 27.7120966,9.59984055 30.2266667,7.39666667 L30.6416667,7.01833333 C31.6583333,6.21333333 33.1866667,6.85666667 33.325,8.145 L33.3333333,8.33333333 L33.3333333,23.3333333 C33.3333333,23.7810569 33.1530719,24.2099269 32.8333333,24.5233333 C29.0633186,28.2190382 23.0698749,28.3474744 19.145,24.8166667 L18.56,24.27 C16.1297387,22.1406324 12.5223492,22.0605619 10,24.08 L10,35 C9.9990219,35.8818223 9.3113159,36.6102746 8.43100864,36.6619535 C7.55070139,36.7136323 6.78248471,36.0706506 6.67833333,35.195 L6.66666667,35 L6.66666667,8.33333333 L6.66666667,8.33333333 Z",
    id: "Path",
    fill: "#C8453A",
    fillRule: "nonzero"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndFlag);
export default __webpack_public_path__ + "static/media/end-flag.5a7a4634743aee0f6db2fe7995f3e12a.svg";
export { ForwardRef as ReactComponent };